import A_CapsuleUserAvatar from '@/components/A_Atoms/A_CapsuleUserAvatar/A_CapsuleUserAvatar';
import styles from './C_CapsuleUserAvatars.module.css';

interface C_CapsuleUserAvatarsProps {
  avatars: string[];
}

export default function C_CapsuleUserAvatars({
  avatars,
}: C_CapsuleUserAvatarsProps) {
  const limitedAvatars = avatars.slice(0, 3);
  const avatarsToRender = limitedAvatars.length > 0 ? limitedAvatars : [''];

  return (
    <div className={styles.wrapper}>
      {avatarsToRender.map((avatar, idx) => (
        <A_CapsuleUserAvatar key={`${avatar}-${idx}`} avatar={avatar} />
      ))}
    </div>
  );
}
